<template>
  <v-layout
    class="add-new-account"
    row
    justify-center>
    <v-dialog
      v-model="mpDialog.show"
      persistent
      scrollable
      max-width="600px">
      <v-card>
        <v-card-title v-if="mpDialog.type === 'new'">Create New Master Payer Account</v-card-title>
        <v-tabs v-model="currentTab">
          <v-tab v-for="item in tabItems" :key="item">
            {{ item }}
          </v-tab>
        </v-tabs>
 
        <v-card-text>
          <v-container>
            <v-tabs-items v-model="currentTab">
            <v-tab-item v-for="item in tabItems" :key="item">
            <v-form v-if="currentTab == 0" 
              ref="generalForm"
              v-model="valid"
              lazy-validation>
              <div style="font-weight:500; font-size:14px">
                NOTE: All fields with
                <span style="color:red">*</span> are required
              </div>
              <v-text-field
                v-validate="'required'"
                v-model="mpDialog.fields.MP_ID"
                :disabled="isRecordView"
                :error="mpDialog.mpIdValidation.error"
                :error-messages="mpDialog.mpIdValidation.errorMessage || errors.collect('mpDialog.fields.MP_ID')"
                :success="mpDialog.mpIdValidation.success"
                :success-messages="mpDialog.mpIdValidation.successMessage"
                required
                data-vv-name="mpDialog.fields.MP_ID"
                data-vv-validate-on="blur"
                @change="validateMpId"
                
              >
                <template slot="label">
                  <span v-html="`MP ID <span class='required'>*</span>`"/>
                </template>
              </v-text-field>
              <v-select
                :items="['AISPL', 'EDP', 'Legacy', 'Perspecta', 'PPA', 'SPP', 'SPP - EDF', 'SPP - FG', 'Customer owned']"
                :readonly="isRecordView"
                v-model="mpDialog.fields.Agreement"
                required>
                <template slot="label">
                  <span v-html="`Agreement <span class='required'>*</span>`"/>
                </template>
              </v-select>
              <v-select
                :items="awsSupportTypes"
                :readonly="isRecordView"
                v-model="mpDialog.fields.AWS_Support_Type"
                attach
                required
              >
                <template slot="label">
                  <span v-html="`AWS Support Type <span class='required'>*</span>`"/>
                </template>
              </v-select>
              <v-select
                :items="['Internal','Dedicated','External','Saas', 'Gold managed svc']",
                :readonly="isRecordView"
                v-model="mpDialog.fields.Type"
                attach
              >
                <template slot="label">
                  <span v-html="`Type <span class='required'>*</span>`"/>
                </template>
              </v-select>
              <v-text-field
                :readonly="isRecordView"
                v-model="mpDialog.fields.MP_discount"
                required>
                <template slot="label">
                  <span v-html="`MP Discount`"/>
                </template>
              </v-text-field>
              <v-text-field
                :readonly="isRecordView"
                v-model="mpDialog.fields.MP_uplift"
                required>
                <template slot="label">
                  <span v-html="`MP Uplift`"/>
                </template>
              </v-text-field>
              <v-text-field
                :readonly="isRecordView"
                v-model="mpDialog.fields.MP_Business_Rules"
                required>
                <template slot="label">
                  <span v-html="`Account Name <span class='required'>*</span>`"/>
                </template>
              </v-text-field>
              <v-text-field
                :readonly="isRecordView"
                v-model="mpDialog.fields.MP_features"
                required>
                <template slot="label">
                  <span v-html="`MP Features`"/>
                </template>
              </v-text-field>
              <v-text-field
                :readonly="isRecordView"
                v-model="mpDialog.fields.MP_Type"
                required>
                <template slot="label">
                  <span v-html="`MP Type`"/>
                </template>
              </v-text-field>
              <v-select
                attach
                :items="['Yes', 'No']"
                :readonly="isRecordView"
                label="Grandfathered"
                v-model="mpDialog.fields.Grandfathered"
              ></v-select>
              <v-select
                attach
                :items="['Yes', 'No']"
                :readonly="isRecordView"
                label="Control Tower Log Usage"
                v-model="mpDialog.fields.CT_Log_Usage"
              ></v-select>
            </v-form>
            <!-- Sync Config Tab -->
            <v-form v-else-if="currentTab == 1" 
              ref="generalForm"
              v-model="valid"
              lazy-validation>
              <v-layout
                row
                justify-center>
                <v-flex xs12 sm6>
                  <v-checkbox
                    v-model="syncEnabledFilter"
                    false-value="0"
                    true-value="1"
                    color="orange"
                    label="Sync Enabled"
                  />
                </v-flex>
                <v-flex> 
                  <v-text-field
                    v-if="mpDialog.type !== 'new'"
                    readonly
                    v-model="mpDialog.fields.Last_Successful_Sync"
                    label="Last Successful Sync"
                  />
                </v-flex>
                <!-- <v-flex>
                  <v-btn
                    v-if="mpDialog.type !== 'new'"
                    small
                  >
                    Trigger Sync&nbsp;
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </v-flex> -->

              </v-layout>

              <v-text-field
                :readonly="isRecordView"
                v-model="mpDialog.fields.Sync_Role"
                label="Sync Role"
                required >
                <template slot="label" v-if="syncEnabledFilter == '1'">
                  <span v-html="`Sync Role <span class='required'>*</span>`"/>
                </template>
              </v-text-field>
              <v-autocomplete
                v-model="selectedCustomer"
                :items="customers"
                :item-text="(item) => `${item.Cust_Region}`"
                :readonly="isRecordView"
                item-value="Customer_Id"
                label="Customer Name"
              />

              
              <!-- <v-text-field
                v-model="mpDialog.fields.Sync_Config.Managed_Services"
                required>
                <template slot="label">
                  <span v-html="`Managed Service`"/>
                </template>
              </v-text-field> -->

              <v-select
                required
                v-model="mpDialog.fields.Sync_Config.Managed_Services"
                :items="['DXC Gold','DXC Silver','AMS (AWS Managed Services)','None']"
                :readonly="isRecordView"
                attach
                label="Managed SVC"
              />

              <v-text-field
                :readonly="isRecordView"
                v-model="mpDialog.fields.Sync_Config.WBS_code"
                label="WBS Code"
                required />

              <v-text-field
                 :readonly="isRecordView"
                v-model="mpDialog.fields.Sync_Config.IWO_code"
                required
                label="IWO Code" />


              <!--Default Account Owners-->
              <div class="owners-header d-flex align-center justify-space-between mb-3">
                <p class="v-label v-label--active theme--light v-ao mb-0">Default Account Owners&nbsp;
                  <v-btn
                    v-if="!isRecordView"
                    small
                    color="orange"
                    class="ml-3"
                    @click="addAccountOwner"
                  >
                    Add Account Owner
                  </v-btn>
                </p>
              </div>
              <p v-if="!syncConfigAccountOwners.length" class="empty-owners">No Account Owners defined</p>
              <div v-if="syncConfigAccountOwners.length" class="account-owners-list">
                <div class="owner-chips-container">
                  <div v-for="(owner, index) in syncConfigAccountOwners" :key="index" class="owner-items">
                    <v-chip class="ma-1 owner-chip" outlined>
                      <span class="owner-name">{{ owner.name }}</span>
                      <span class="owner-email">&nbsp;|&nbsp;{{ owner.email }}</span>
                      <v-icon v-if="!isRecordView" small class="ml-2" @click.stop="toggleEditForm(index)">edit</v-icon>
                      <v-icon v-if="!isRecordView" small class="ml-2" @click="deleteItem(owner)">delete</v-icon>
                    </v-chip>
                  </div>
                </div>

                <v-expand-transition>
                  <div v-if="editingIndex !== null" class="owner-edit-form mt-3">
                    <v-text-field
                      dense
                      v-model.trim="editingOwner.name"
                      label="Name"
                      class="mb-2"
                    />
                    <v-text-field
                      dense
                      v-model.trim="editingOwner.email"
                      label="Email"
                      class="mb-2"
                    />
                    <v-text-field
                      dense
                      v-model.trim="editingOwner.phone"
                      label="Phone"
                      class="mb-2"
                    />
                    <div class="edit-form-actions">
                      <v-btn small color="orange" class="mr-2" @click="saveEditedOwner(editingIndex)">{{ editingIndex === -1 ? 'Add' : 'Save' }}</v-btn>
                      <v-btn small @click="cancelEditForm">Cancel</v-btn>
                    </div>
                  </div>
                </v-expand-transition>
              </div>
              <v-expand-transition>
                <div v-if="editingIndex === -1 && !syncConfigAccountOwners.length" class="owner-edit-form mt-3">
                  <v-text-field
                    dense
                    v-model.trim="editingOwner.name"
                    label="Name"
                    class="mb-2"
                  />
                  <v-text-field
                    dense
                    v-model.trim="editingOwner.email"
                    label="Email"
                    class="mb-2"
                  />
                  <v-text-field
                    dense
                    v-model.trim="editingOwner.phone"
                    label="Phone"
                    class="mb-2"
                  />
                  <div class="edit-form-actions">
                    <v-btn small color="orange" class="mr-2" @click="saveEditedOwner(editingIndex)">Add</v-btn>
                    <v-btn small @click="cancelEditForm">Cancel</v-btn>
                  </div>
                </div>
              </v-expand-transition>
              


            </v-form>
            </v-tab-item>
            </v-tabs-items>
          </v-container>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-tabs-items v-model="currentTab">
            <v-tab-item v-for="item in tabItems" :key="item">
            
            <v-card-actions>
              <v-btn @click.stop="onCancel">Close</v-btn>
              <v-btn
                v-if="$can('write', 'master-payer') && !isRecordView"
                :loading="mpDialog.saving"
                :disabled="mpDialog.saving || !formComplete || errors.items.length > 0 || mpDialog.mpIdValidation.error === true || !syncConfigComplete"
                color="orange"
                @click="mpDialog.submitHandler(mpDialog.fields)"
              >{{ mpDialog.submitLabel }}</v-btn>
            </v-card-actions>

            <!-- <v-card-actions v-else-if="currentTab == 1">
              <v-btn @click.stop="onCancel">Close</v-btn>
              <v-btn
                v-if="$can('write', 'master-payer') && !isRecordView"
                :loading="mpDialog.saving"
                :disabled="!formComplete || errors.items.length > 0 || mpDialog.mpIdValidation.error === true || !syncConfigComplete"
                color="orange"
                @click="mpDialog.submitHandler(mpDialog.fields)"
              >{{ mpDialog.submitLabel }}</v-btn>
            </v-card-actions> -->
            </v-tab-item>
          </v-tabs-items>
          <v-alert
            v-model="mpDialog.showResponse"
            :dismissible="true"
            :type="mpDialog.responseType"
            class="m0 p0"
          >
            {{ mpDialog.responseMessage }}</v-alert>
        </v-card-actions>
      </v-card>

    </v-dialog>

  </v-layout>
</template>
<script>
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      editingIndex: null,
      editingOwner: {
        name: '',
        email: '',
        phone: ''
      },
      valid: true,
      step: 1,
      search: null,
      awsSuppType: ['Enterprise', 'Business', 'Developer', 'Basic', 'Enterprise Support', 'Business Support+', 'Basic Support'],
      type: ['Internal', 'Dedicated', 'External', 'Saas'],
      tabItems: ['MP', 'Sync Config'],
      currentTab: 0
    }
  },
  mounted () {
    this.normalizeSyncConfigAccountOwners()
  },
  computed: {
    ...mapState('admin', ['mpDialog', 'customers']),
    ...mapState('admin/accountInventory', ['awsSupportTypes']),
    ...mapState('user/requestAws', ['newAwsAcctExistingClient']),
    syncConfigAccountOwners () {
      const syncConfig = this.mpDialog.fields.Sync_Config || {}
      return Array.isArray(syncConfig.Account_Owners) ? syncConfig.Account_Owners : []
    },
    formComplete () {
      return (
        this.mpDialog.fields.MP_ID &&
        this.mpDialog.fields.Agreement &&
        this.mpDialog.fields.AWS_Support_Type &&
        this.mpDialog.fields.Type &&
        this.mpDialog.fields.MP_Business_Rules
      )
    },
    selectedCustomer: {
      get() {
        debugger
        const syncConfigCustId = this.mpDialog.fields.Sync_Config.Customer_Id
        const selectedCustomer = this.customers.find(customer => customer.Customer_Id == syncConfigCustId);
        return selectedCustomer ? selectedCustomer.Customer_Id : ""
      },
      set(value){
        debugger
        this.mpDialog.fields.Sync_Config.Customer_Id = Number(value);
      }
    },
    syncConfigComplete() {

      if (this.syncEnabledFilter == '1') {
        if (!this.mpDialog.fields.Sync_Role) {
          return false
        }
      }

      return true
    },
    syncEnabledFilter: {
      get() {
        return this.mpDialog.fields.Sync_Enabled
      },
      set(sync_enabled) {
        const date = new Date();
        const formattedDate = date.toISOString().slice(0, 19).replace('T', ' ')
        this.mpDialog.fields.Sync_Enabled = sync_enabled
        if (sync_enabled === 1 || sync_enabled === '1') {
          this.mpDialog.fields.Sync_Enabled_At = formattedDate
          this.mpDialog.fields.Sync_Disabled_At = null
        } else {
          this.mpDialog.fields.Sync_Disabled_At = formattedDate
          this.mpDialog.fields.Sync_Enabled_At = null
        }
      }
    },
    isRecordView() {
      return this.mpDialog.type === 'view'
    },
  },
  watch: {
    'mpDialog.fields.Sync_Config': {
      handler () {
        this.normalizeSyncConfigAccountOwners()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      validateMPId: 'admin/validateMasterPayerMPId'
    }),
    onCancel () {
      console.log('masterpayer cancel')
      this.$store.commit(
        'showDialog',
        {
          show: true,
          type: 'confirmation',
          persistent: true,
          title: 'Are you sure you to close this window?',
          yesLabel: 'Yes',
          yesHandler: () => {
            this.$store.commit('showDialog', { show: false })
            this.$store.commit('admin/resetMasterPayerDialog')
            this.$store.commit('admin/clearValidationErrors')
          },
          noHandler: () => {
            this.$store.commit('showDialog', { show: false })
          },
          noLabel: 'No'
        },
        { root: true }
      )
    },
    validateMpId () {
      let mpId = this.mpDialog.fields.MP_ID
      if (isNaN(mpId)) {
        console.log('is not a number')
        this.$store.commit('admin/setMpIdValidation', {
          error: true,
          success: false,
          errorMessage: 'MP_ID should be numeric'
        })
      } else {
        console.log('is a number')
        this.validateMPId(this.mpDialog.fields.MP_ID)
      }
    },
    normalizeSyncConfigAccountOwners () {
      const fields = this.mpDialog.fields || {}
      if (!fields.Sync_Config || Array.isArray(fields.Sync_Config)) {
        this.$set(fields, 'Sync_Config', {
          Customer_Id: null,
          Managed_Services: null,
          WBS_code: null,
          IWO_code: null,
          Account_Owners: []
        })
        return
      }

      const owners = fields.Sync_Config.Account_Owners
      if (!owners) {
        this.$set(fields.Sync_Config, 'Account_Owners', [])
        return
      }
      if (Array.isArray(owners)) {
        return
      }
      if (typeof owners === 'string') {
        try {
          const parsed = JSON.parse(owners)
          this.$set(fields.Sync_Config, 'Account_Owners', Array.isArray(parsed) ? parsed : [])
          return
        } catch (e) {
          this.$set(fields.Sync_Config, 'Account_Owners', [])
          return
        }
      }
      if (typeof owners === 'object') {
        this.$set(fields.Sync_Config, 'Account_Owners', [owners])
        return
      }
      this.$set(fields.Sync_Config, 'Account_Owners', [])
    },
    deleteItem (item) {
      const owners = this.syncConfigAccountOwners
      const idx = owners.indexOf(item)
      if (idx > -1) {
        owners.splice(idx, 1)
        this.$set(this.mpDialog.fields.Sync_Config, 'Account_Owners', [...owners])
      }
    },
    toggleEditForm (index) {
      const owner = this.syncConfigAccountOwners[index]
      this.editingIndex = index
      this.editingOwner = {
        name: owner.name || '',
        email: owner.email || '',
        phone: owner.phone || ''
      }
    },
    addAccountOwner () {
      this.editingIndex = -1
      this.editingOwner = { name: '', email: '', phone: '' }
    },
    saveEditedOwner (index) {
      const updated = {
        name: this.editingOwner.name.trim(),
        email: this.editingOwner.email.trim(),
        phone: this.editingOwner.phone.trim()
      }

      if (index === -1) {
        this.$set(this.mpDialog.fields.Sync_Config, 'Account_Owners', [...this.syncConfigAccountOwners, updated])
      } else {
        this.$set(this.mpDialog.fields.Sync_Config.Account_Owners, index, updated)
        this.$set(this.mpDialog.fields.Sync_Config, 'Account_Owners', [...this.syncConfigAccountOwners])
      }

      this.cancelEditForm()
    },
    cancelEditForm () {
      this.editingIndex = null
      this.editingOwner = { name: '', email: '', phone: '' }
    }
  }
}
</script>
<style lang="scss">
.add-new-account {
  .theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused
    > .v-input__control
    > .v-input__slot {
    background: #7e7e7e;
  }
}

.account-overlay {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 5;
}
.required label::after {
  content: "*";
}

.empty-owners {
  font-style: italic;
  color: #757575;
  padding-bottom: 17px;
}

.account-owners-list {
  margin: 20px 0;
}

.owner-chips-container {
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #fafafa;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: flex-start;
}

.owner-items {
  min-width: 0;
  max-width: 100%;
}

.owner-chip {
  height: auto !important;
  max-width: 100%;
}

.owner-chip::v-deep .v-chip__content {
  display: flex;
  flex-wrap: wrap;
  white-space: normal;
  word-break: break-word;
}

.owner-name {
  font-weight: 500;
  font-size: 14px;
  color: #333;
  word-break: break-word;
}

.owner-email {
  font-size: 12px;
  color: #666;
  word-break: break-word;
}

.owner-edit-form {
  padding: 12px;
  border: 1px solid #e0e0e0;
  margin-top: 12px;
  border-radius: 4px;
  background-color: #f2ecec;
  width: 100%;
}

.edit-form-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.v-ao {
  font-size: 16px !important;
  font-weight: 500;
}

@media (max-width: 600px) {
  .owners-header {
    align-items: flex-start !important;
  }

  .owners-header .v-ao {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    white-space: normal;
  }

  .owners-header .v-btn {
    margin-left: 0 !important;
  }

  .owner-chip {
    width: 100%;
  }

  .edit-form-actions .v-btn {
    width: 100%;
  }
}
</style>
